export const VIRTUALPAGEPATHS = {
  EC_FORM: '/expert-check/form',
  EC_TOO_LONG: '/expert-check/paper-too-long',
  EC_SUCCESS: ' /expert-check/submitted-success',
  EC_WAITING: '/expert-check/waiting',
  EC_UPGRADE: '/expert-check/nonsubscribed',
  PROCESSING_YOUR_PAPER: '/virtual-pageview/paperchecker/processing-your-paper',
  PAPER_PROCESSED: '/virtual-pageview/paperchecker/paper-processed',
  GRAMMAR_CHECK: '/virtual-pageview/paperchecker/grammar-check',
  PLAGIARISM_CHECK: '/virtual-pageview/paperchecker/plagiarism-check',
  PLAGIARISM_SOURCES: '/virtual-pageview/paperchecker/plagiarism-sources',
  SIGN_IN: '/virtual-pageview/sign-in',
  SIGN_UP: '/virtual-pageview/sign-up',
}

export const EVENT_CATEGORY = {
  ACCOUNT: 'account',
  PAPERCHECKER_ENGAGEMENTS: 'paperchecker engagements',
  PAPERCHECKER_FUNNEL: 'paperchecker funnel',
  PAPERCHECKER_ERROR: 'paperchecker error',
  NAVIGATION_BAR: 'navigation bar',
  OUTBOUND_LINK: 'outbound link',
}

export const EVENT_ACTIONS = {
  EXPERT_CHECK: 'expert check',
  LOGIN: 'login',
  SIGN_UP: 'sign up',
  MY_PAPERS: 'go to my papers',
  LOGOUT: 'log out',
  CHECK_FOR_PLAGIARISM: 'check for plagiarism',
  SIGNUP_FOR_PLUS_CTA: 'signup for plus cta',
  SIGNUP_FOR_FREE_CTA: 'signup for free cta',
  SIGNIN_CTA: 'signin cta',
  SUGGESTION_CARDS_GRAMMAR_AND_SPELLING: 'suggestion cards - grammar and spelling',
  SUGGESTION_CARDS_CITATIONS: 'suggestion cards citations',
  CHECK_FAILURE: 'check failure',
  DELETE_PAPER: 'delete paper',
  OPEN_PREVIOUS_PAPER: 'open previous paper',
  VIEW_PLAGIARISM_SOURCE: 'view plagiarism source',
  COPY_PAPER: 'copy paper',
  DOWNLOAD_PAPER: 'download paper',
  VIEW_GRAMMAR: 'view grammar',
  VIEW_PLAGIARISM: 'view plagiarism',
  RECHECK_PLAGIARISM: 'recheck plagiarism',
  RECHECK_GRAMMAR: 'recheck grammar',
  SELECT_COPY_PAPER: 'copy selected paper',
  CLICK_GRAMMAR_OWL_LINK: 'click grammar owl learn it link',
  LANGUAGE_SWITCHER: 'language switcher',
  CLICK_TOP_HEADER_NAV_LINK: 'click nav element',
  BETTER_WRITING_PLUS_SIGN_UP: 'signup for plus cta',
  BEST_WRITING_PLUS_SIGN_UP: 'non-social | to=https://www.chegg.com/study-pack',
  CLICK_GRAMMAR_CARD_CTA: 'click grammar card cta',
  CLICK_UNSUPPORTED_CLAIMS_CTA: 'click unsupported claims cta',
}

export const EVENT_LABELS = {
  EXPERT_CHECK_SUBMISSION_FORM: 'expert check submission form',
  EXPERT_CHECK_UPLOAD: 'upload different paper',
  EXPERT_CHECK_EDIT: 'edit paper too long',
  EXPERT_CHECK_SUBMIT_SUCCESS: 'submit paper success',
  EXPERT_CHECK_SUBMIT_ERROR: 'submit paper error',
  EXPERT_CHECK: 'expert check page',
  PAPER_PROCESSED_MODAL: 'paper processed modal',
  SUCCESS: 'success',
  HEADER_NAVIGATION: 'header navigation',
  HEADER_LINKS: 'header link',
  UNLOCKED_CARD: 'unlocked card',
  EDITOR_CTA: 'editor cta',
  CLICK_ON_ERROR_TEXT: 'click on error text',
  PLAGIARISM_CHECK: 'plagiarism check',
  GRAMMAR_CHECK: 'grammar check',
  MY_PAPERS_PAGE: 'my papers page',
  LINK_OUT: 'link out',
  UPGRADE_TO_RECHECK: 'upgrade to recheck',
  PLAGIARISM_LOCK: 'access plagiarism midpanel',
  GRAMMAR_LOCK: 'grammar card upsell',
  FREE_GRAMMAR_EMPTY_STATE: 'free grammar empty state',
  NAV_LINK: 'nav link',
  PRECHECK_PLAG_EMPTY_STATE: 'precheck plag empty state',
  PLUS_GRAMMAR_EMPTY_STATE: 'plus grammar empty state',
  PLAGIARISM_EMPTY_STATE: 'plagiarism empty state',
  SEE_SOURCES: 'see sources',
  UPSELL_MODAL_LINK: 'upsell modal link',
  EDITOR_SELECT_COPY: 'editor select copy',
  GRAMMAR_OWL_LINK: 'owl learn it',
  LANGUAGE_SWITCHER_US: 'U.S. English',
  LANGUAGE_SWTICHER_UK: 'U.K. English',
  PAYMENT_TIERS_INTERSTITIAL: 'payment tiers interstitial',
  WRITING_PAYMENT_TIERS_INTERSTITIAL: 'writing payment tiers interstitial',
  SIGN_IN: 'sign in',
  CREATE_ACCOUNT: 'create account',
  CREATE_ACCOUNT_NAV_LINK: 'create account - nav link',
  SAVE_NAV_LINK: 'save - nav link',
  MY_PAPERS: 'my papers',
  GRAMMAR_CARD_TO_EXPERT_CHECK_CTA: 'grammar card to expert check cta',
  UNSUPPORTED_CLAIMS: 'unsupported claims',
}

export const EVENT_TYPES = {
  EVENT: 'event',
  VIRTUALPAGE: 'virtualPage',
}



// WEBPACK FOOTER //
// ./src/state/gtm/definitions/constants.ts